/* unplugin-vue-components disabled */import script from "./category_month_index.vue?vue&type=script&setup=true&lang=js"
export * from "./category_month_index.vue?vue&type=script&setup=true&lang=js"

import "./category_month_index.vue?vue&type=style&index=0&id=2258c185&lang=less&scoped=true"
import "./category_month_index.vue?vue&type=style&index=1&id=2258c185&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2258c185"]])

export default __exports__